
webpack.register(
    'modules/qualifying-tabs/qualifying-tabs',
    function() {
        return import('modules/qualifying-tabs/qualifying-tabs');
    },
    true
);